<template>
  <!--用户配置列表页面模版-->
  <div class="main">
    <a-card>
      <a-form layout="inline">
        <a-row>
          <a-col :span="6">
            <a-form-item label="用户名称:" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="query.userName" style="width: 200px"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="手机号码:">
              <a-input v-model="query.phone"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="状态:" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select placeholder="请选择状态" style="width: 200px" v-model="query.ifOpen">
                <a-select-option value="0"> 开启 </a-select-option>
                <a-select-option value="1"> 关闭 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="mag-bot">
            <span>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 30px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 30px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 30px" @click="deleteSelectRowdel" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
        <!--表单-->
        <a-table
          size="middle"
          rowKey="id"
          :data-source="tableData"
          :columns="columns"
          :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
          bordered
          :pagination="pagination"
          @change="pageChange"
        >
          <span slot="action" slot-scope="text, record">
            <a class="a-text" @click="editItem(record.id)" v-action:edit>编辑</a>
          </span>
          <!--状态显示颜色区域-->
          <span slot="ifOpen" slot-scope="text, record">
            <!-- <a-tag color="#f12b35"
                   v-if="text == 0">关闭</a-tag>
            <a-tag color="rgb(50, 205, 50)"
                   v-else>开启</a-tag> -->
            <!-- <a-switch :checked="record.ifOpen == 0 ? true : false" @change="onRevealChangeUpdate(record)" /> -->
              {{ record.ifOpen == 0 ? '开启' : '关闭'}}
          </span>
          <span slot="dataSource" slot-scope="text">
            <a-tag color="#C3C1E9" v-if="text == 0">后台新增</a-tag>
            <a-tag color="rgb(66, 211, 9)" v-else>用户注册</a-tag>
          </span>
        </a-table>
      </a-form>
    </a-card>
    <a-modal :title="isEditMode ? '编辑' : '新增'" v-model="addOrUpdateVisible" width="30%">
      <a-form :form="addOrUpdateForm">
        <a-row>
          <a-col :md="18">
            <a-form-item label="手机号码:" :labelCol="{ span: 7, offset: 2 }" :wrapperCol="{ span: 8 }">
              <a-input
                style="width: 300px"
                v-decorator="['phone', { rules: [{ required: true, message: '请输入手机号码' }] }]"
                :disabled="this.isUpdate"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row v-if="isEditMode == true">
          <a-col :md="18">
            <a-form-item label="租户名称:" :labelCol="{ span: 7, offset: 2 }" :wrapperCol="{ span: 8 }">
              <a-input
                :disabled="this.isUpdate"
                style="width: 300px"
                v-decorator="['tenantName', { rules: [{ required: true, message: '请输入租户名称' }] }]"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :md="18">
            <a-form-item label="部门名称:" :labelCol="{ span: 7, offset: 2 }" :wrapperCol="{ span: 8 }">
              <a-input
                style="width: 300px"
                v-decorator="['departmentName', { rules: [{ required: true, message: '请输入部门名称' }] }]"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :md="18">
            <a-form-item label="用户名称:" :labelCol="{ span: 7, offset: 2 }" :wrapperCol="{ span: 8 }">
              <a-input
                style="width: 300px"
                v-decorator="['userName', { rules: [{ required: true, message: '请输入用户名称' }] }]"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col>
            <a-form-item label="是否开启状态" :labelCol="{ span: 5, offset: 2 }" :wrapperCol="{ span: 8 }">
              <a-radio-group v-decorator="['ifOpen', { initialValue: 0, rules: [{ required: true }] }]">
                <a-radio :value="1">不开启</a-radio>
                <a-radio :value="0">开启</a-radio>
              </a-radio-group>
              <!-- <a-switch @change="onRevealChange"
                        v-decorator="['ifOpen', { valuePropName: 'checked' }]" /> -->
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <span slot="footer">
        <a-button @click="addOrUpdateVisible = false">关 闭</a-button>
        <a-button type="primary" @click="submitForm" :loading="loading" v-action:edit>确 定</a-button>
      </span>
    </a-modal>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '手机号码',
    dataIndex: 'phone',
    align: 'center',
  },
  {
    title: '用户名称',
    dataIndex: 'userName',
    align: 'center',
  },
  {
    title: '部门名称',
    dataIndex: 'departmentName',
    align: 'center',
  },
  {
    title: '数据来源',
    dataIndex: 'dataSource',
    align: 'center',
    scopedSlots: { customRender: 'dataSource' },
  },
  {
    title: '租户名称(单位名称)',
    dataIndex: 'tenantName',
    align: 'center',
  },
  {
    title: '状态',
    dataIndex: 'ifOpen',
    align: 'center',
    scopedSlots: { customRender: 'ifOpen' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  mixins: [mixinViewModule],
  name: 'UserConfiguration',
  data() {
    return {
      // 新增编辑表单效验默认选中
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      addOrUpdateVisible: false,
      isEditMode: false,
      isadd: false,
      orderColumn: '', // 排序列
      orderType: 'asc', // 正序为asc。倒序为desc
      needPage: true, // 是否需要分页
      isUpdate: false, // 是否更新数据
      currentId: '', // 更新数据的id
      addOrUpdateUrl: '/gis-manager/user/deploy/add',
      updateUrl: '/gis-manager/user/deploy/update',
      deleteUrl: '/gis-manager/user/deploy/remove',
      ifOpen: '1',
      isShowOfpen: false,

      // 查询参数
      query: {
        phone: '',
        tenantName: '',
        departmentName: '',
        userName: '',
        ifOpen: '',
      },
      dataListLoading: false, // 加载中
      selectedRows: [], // 选中的所有行
      // 表格数据
      tableData: [],

      // 分页数据
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      columns,
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      loading: false, // 添加 loading 状态
    }
  },
  computed: {},
  created() {
    this.resetList()
    this.queryList()
  },
  mounted() {
    this.queryList()
  },
  methods: {
    //编辑弹窗查询一条数据
    editItem(id) {
      this.isUpdate = false
      this.isEditMode = true
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get('/gis-manager/user/deploy/get/' + id)
          .then((res) => {
            console.log(res)
            this.currentId = res.data.id
            this.addOrUpdateForm.setFieldsValue(res.data)
          })
          .catch(() => {
            this.$message.error('获取数据失败')
          })
      }
    },
    submitForm(e) {
      e.preventDefault()
      this.loading = true // 开始加载
      if (this.isEditMode) {
        // 编辑确定修改逻辑
        this.addOrUpdateForm.validateFields((err, values) => {
          if (!err) {
            this.$http
              .post(this.updateUrl, {
                id: this.currentId,
                ...values,
              })
              .then((res) => {
                if (res.code === 0) {
                  this.addOrUpdateVisible = false
                  this.queryList()
                  this.$message.success(res.message)
                }
              })
              .catch(() => {
                console.log('更新数据失败！')
              })
              .finally(() => {
                this.loading = false // 结束加载
              })
          } else {
            this.loading = false // 结束加载
          }
        })
      } else {
        // 新增逻辑
        this.addOrUpdateForm.validateFields((err, values) => {
          if (!err) {
            this.$http
              .post(this.addOrUpdateUrl, {
                ...values,
              })
              .then((res) => {
                if (res.code === 0) {
                  this.addOrUpdateVisible = false
                  this.queryList()
                  this.$message.success(res.message)
                }
              })
              .catch(() => {
                this.loading = false // 结束加载
              })
              .finally(() => {
                this.loading = false // 结束加载
              })
          } else {
            this.loading = false // 结束加载
          }
        })
      }
    },
    // 重置列表
    resetList() {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    // 表单查询
    queryList() {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get('/gis-manager/user/deploy/page', { params })
        .then((res) => {
          console.log('*-*-*-*-==>>', res)
          this.dataListLoading = false
          if (this.needPage) {
            this.tableData = res.data.list || []
            this.selectedRows = []
            this.pagination.total = res.data.total ? parseInt(res.data.total) : 0
            if (res.data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.tableData = res.data.list || []
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 表格多选操作
    onSelectChange(selectedRowKeys) {
      this.selectedRows = selectedRowKeys
    },
    //单选多选删除数据
    deleteSelectRowdel() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      console.log(_this.selectedRows)
      _this.selectedRows = _this.selectedRows.map(Number)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .post(_this.deleteUrl, _this.selectedRows)
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.resetList()
                _this.queryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    },
    // 分页查询
    pageChange(pagination, filters, sorter) {
      console.log('ou->pageChange')
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.pageQueryList()
    },
    pageQueryList() {
      console.log('ou->pageQueryList')
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get('/gis-manager/user/deploy/page', {
          params,
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.tableData = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.tableData = data.list || []
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    onRevealChangeUpdate(e) {
      if (e.ifOpen == '0') {
        e.ifOpen = '1'
      } else {
        e.ifOpen = '0'
      }
    },
  },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  min-height: 100%;
}

.span,
a:hover {
  color: rgb(66, 211, 9);
}

.mag-bot {
  margin-top: 15px;
}

/deep/.ant-table-body {
  margin-top: 15px;
}
</style>
